export default "__VITE_ASSET__62573e78__"